import React, { useEffect, useState } from "react";
import InstallationView from "./InstallationView";
import crmservices from '../../wsclient';
import { httpBackOfficeUtil } from "../../wsclient/crmservices/httpBackOfficeUtil";
import { useTranslation } from "react-i18next";
import InstallationDetailView from "./InstallationDetailView";
import { sleep } from "../../utils/util";
import ConfirmComponent from "../../components/Confirm";
import UploadFile from "../../components/UploadFile";
import { getCustomFieldByKey } from "../../utils/util";
import { getData } from "../../utils/common";
import { connection } from "../../portal.config";

const MAXIUM_FILE = 3;
export default function InstallationController(props) {
	const { t } = useTranslation();
	const [showConfirm, setShowConfirm] = useState();
	const [installations, setInstallations] = useState([]);
	const [showLoadingInstallation, setShowLoadingInstallation] = useState(true);
	const [showOrderDetail, setShowOrderDetail] = useState(false);
	const [orderDetail, setOrderDetail] = useState(null);
	const [activities, setActivities] = useState([]);
	const [updateActivitiesNote, setUpdateActivitiesNote] = useState();
	const [showUploadFile, setShowUploadFile] = useState(false);
	const [activityForUpload, setActivityForUpload] = useState(null);
	const [filesUpload, setFilesUpload] = useState([]);
	const [files, setFiles] = useState([]);
	const [contactAttachments, setContactAttachments] = useState([]);
	const [isLoadedAttachments, setIsLoadedAttachments] = useState(false);
	const [isReloadAttachment, setIsReloadAttachment] = useState(false);
	const [paging, setPaging] = useState({
		page: 1,
		size: 10,
		total: 0,
		has_more: false
	});

	const setShowProcessing = props.setShowProcessing;
	const showMessage = props.showMessage;

	useEffect(() => {
		if (props.stageId) {
			onLoadListInstallation();
		}
	}, [props.stageId]);

	useEffect(() => {
		if (orderDetail && orderDetail.contact && orderDetail.contact.id) {
			onLoadContactAttachments(orderDetail.contact.id);
		}
	}, [orderDetail]);

	useEffect(() => {
		if (isReloadAttachment) {
			console.log("BBBBBBBBBBBB");
			console.log("BBBBBBBBBBBB");
			console.log("BBBBBBBBBBBB");
			onLoadContactAttachments(orderDetail.contact.id);
		}
	}, [isReloadAttachment]);

	useEffect(() => {
		if (isLoadedAttachments) {
			updateActivities(contactAttachments);
		}
	}, [isLoadedAttachments]);

	const updateActivities = (attachments,lstActivities) => {
		let _activities = lstActivities ? lstActivities : activities;
		_activities = _activities.map(a => {
			let custom_fields = a.custom_fields;
			let fileCustomFields = getCustomFieldByKey(custom_fields, 'attachments_file_id');
			if (fileCustomFields) {
				let contactFiles = attachments.filter(attm => {
					return fileCustomFields.includes(attm.file.id);
				})
				if (contactFiles && contactFiles.length > 0) {
					a.file = contactFiles[0];
				}
			}
			return a;
		})
		console.log("AAAAAA _activities:", _activities);
		console.log("AAAAAA _activities:", _activities);
		console.log("AAAAAA _activities:", _activities);
		setActivities(_activities);
	}

	const onLoadContactAttachments = async (contactId) => {
		let attachments = [];
		try {
			const result = await crmservices.attachments.getListAttachments({ contact_id: contactId });
			if (result.code == 'OK') {
				attachments = result.data.content ? result.data.content : [];
			}
		} catch (ex) {

		}
		setContactAttachments(attachments);
		setIsLoadedAttachments(true);
		return attachments;
	}

	const onLoadListInstallation = async (page, size) => {
		let data = [];
		let _paging = {
			page: 1,
			size: 10,
			total: 0
		}
		try {
			let myUserId = httpBackOfficeUtil.getSession().sub;
			var result = await crmservices.orders.getListInstallation({
				page: page ? page : paging.page,
				size: size ? size : paging.size,
				stage_id: props.stageId,
				custom_fields: `assigned_to;${myUserId}`,
				include_total: true,
			});
			if (result.code === 'OK') {
				console.log("result:", result);
				data = result.data.content ? result.data.content : [];
				_paging = result.data.paging;
				if (_paging.size < paging.size) {
					_paging.size = paging.size
				}
			}
			setInstallations(data);
			setPaging(_paging)
		} catch (error) {
			console.log("load installations error:", error);
		}
		setShowLoadingInstallation(false);
	}

	const handleChangePage = async (page) => {
		console.log("AAA page:", page);
		await onLoadListInstallation(page);
	}

	const handleChangeRowsPerPage = async (size) => {
		console.log("AAA size:", size);
		await onLoadListInstallation(1, size);
	}

	const setAddress = async (installation) => {
		let contactId = installation.contact ? installation.contact.id : null;
		try {
			const result = await crmservices.contacts.getContact(contactId);
			if (result.code == 'OK') {
				let contactAddresses = result.data.addresses;
				let primaryAddress = contactAddresses.filter(address => address.is_primary === true)[0];
				return { ...installation, contact_address: primaryAddress };
			}
		} catch (ex) {

		}
	}

	const onShowDetail = async (installation) => {
		console.log('installation:', installation);
		installation = await setAddress(installation)
		if (orderDetail && orderDetail.id == installation) {
			setShowOrderDetail(true);
			setFiles([]);
			setFilesUpload([]);
		} else {
			setIsLoadedAttachments(false);
			setShowProcessing(true);
			try {
				let isLinkedActivity = false;
				let _activities = [];
				const activityTypeId = props.activityTypeId;
				const result = await crmservices.activities.getActivities({
					type_id: activityTypeId,
					order_id: installation.id,
				})
				if (result.code == 'OK' && result.data.content && result.data.content.length > 0) {
					isLinkedActivity = true;
					_activities = result.data.content
				}
				if (isLinkedActivity) {
					const result = await crmservices.orders.getOrderDetail(installation.id);
					if (result.code == 'OK') {
						installation = { ...installation, ...result.data };
					}
					setOrderDetail(installation);
					setActivities(_activities);
					setShowOrderDetail(true);
				} else {
					showMessage({
						status: true,
						message: t('NO_ACTIVITY_FOR_ORDER'),
						title: t('ERROR'),
					});
				}
			} catch (ex) {
				console.log("onShowDetail ex:", ex);
				showMessage({
					status: true,
					message: t('EXCEPTION_PROCESS'),
					title: t('ERROR'),
				});
			}
			setShowProcessing(false);
		}
	}

	const onSubmitUpdateActivity = async (activity, strFileUploaded) => {
		let payload = {
			activity_id: activity.id, state: "COMPLETED"
		}
		let response = {
			status: false
		}
		let custom_fields = activity.custom_fields ? activity.custom_fields : [];
		console.log("custom_fields:", custom_fields);
		if (activity.note) {
			custom_fields = createCustomFieldObj(custom_fields, activity.note);
		}
		if (strFileUploaded) {
			let fileCustomFields = getCustomFieldByKey(custom_fields, 'attachments_file_id');
			if (fileCustomFields) {
				fileCustomFields = fileCustomFields + "," + strFileUploaded
			} else {
				fileCustomFields = strFileUploaded;
			}
			custom_fields.push({
				key: 'attachments_file_id',
				value: fileCustomFields
			})
		}
		payload.custom_fields = custom_fields;
		console.log("payload:", payload);
		try {
			const result = await crmservices.activities.updateActivity({ custom_fields: custom_fields, activity_id: activity.id, state: "COMPLETED" });
			if (result.code == 'OK') {
				response.status = true;
			} else {
				response.errorData = result.data;
			}
		} catch (ex) {
			console.log("onSubmitUpdateActivity ex:", ex);
			response.errorData = ex;
		}
		return response
	}

	const createCustomFieldObj = (custom_fields, newValue) => {
		let newCustomFields = custom_fields.filter(c => {
			return c.key != 'notes';
		})
		newCustomFields.push({
			key: "notes",
			value: newValue
		})

		return newCustomFields;
	}

	const onChangeNote = (activity, event) => {
		let newActivities = activities.map(item => {
			if (activity.id == item.id) {
				item.note = event.target.value;
			}
			return item;
		})
		setActivities(newActivities);
	}
	const onCompleteActivity = async (activity) => {
		setUpdateActivitiesNote(null);
		setShowProcessing(true);
		try {
			const fileUploaded = await onUploadFile(activity);
			let strFileUploaded = fileUploaded && fileUploaded.length > 0 ? fileUploaded.join(",") : null;

			const result = await onSubmitUpdateActivity(activity, strFileUploaded);
			if (result.status) {
				const lstActivitiesResult = await crmservices.activities.getActivities({
					type_id: props.activityTypeId,
					order_id: orderDetail.id,
				})
				console.log('lstActivitiesResult:', lstActivitiesResult);
				if (lstActivitiesResult.code == 'OK') {
					let _activities = lstActivitiesResult.data.content ? lstActivitiesResult.data.content : [];
					let filterActivitiesPending = _activities.filter(a => {
						return a.state == "PENDING";
					})
					if (filterActivitiesPending && filterActivitiesPending.length == 0) {
						await sleep(4000);
						await onLoadListInstallation();
						props.onReloadInstallationList();
						setShowOrderDetail(false);
					} else {
						console.log("AAAAAAAAAAAAAAAAAAAAAA");
						console.log("AAAAAAAAAAAAAAAAAAAAAA");
						console.log("AAAAAAAAAAAAAAAAAAAAAA");
						console.log("AAAAAAAAAAAAAAAAAAAAAA");
						console.log("AAAAAAAAAAAAAAAAAAAAAA");
						if (strFileUploaded) {
							const attachments = await onLoadContactAttachments(orderDetail.contact.id);
							updateActivities(attachments,_activities);
						} else {
							setActivities(_activities);
						}
						setFiles([]);
					}
				} else {
					showMessage({ status: true, message: t('EXCEPTION_PROCESS') })
				}
			} else {
				showMessage({ status: true, message: t('COMPLETE_ACTIVITY_FAIL') })
			}
		} catch (ex) {
			console.log("AAAAAAAAAAAAAAAAAAAAAA ex:",ex);
			showMessage({ status: true, message: t('EXCEPTION_PROCESS') })
		}
		setShowProcessing(false);
	}

	const onAddContactAttachment = async (file_id) => {
		let successfull = false;
		try {
			const contactId = orderDetail.contact.id;
			let result = await crmservices.attachments.addContactAttachment({
				file_id: file_id,
				contact_id: contactId
			});
			if (result.code == 'OK') {
				successfull = true;
			}
			console.log("AAAA onAddContactAttachment result: ", result)
		} catch (error) {
			console.log("onAddContactAttachment exception:", error);
		}
		return successfull;
	}

	const onCompleteAllActivity = async () => {
		console.log('onCompleteAllActivity activities:', activities);
		setUpdateActivitiesNote(null);
		setShowProcessing(true);
		try {
			let _activities = activities.filter(a => {
				return a.state == "PENDING";
			})
			let countProcess = 0;
			for (let i = 0; i < _activities.length; i++) {
				let activity = _activities[i];
				const fileUploaded = await onUploadFile(activity);
				let strFileUploaded = fileUploaded && fileUploaded.length > 0 ? fileUploaded.join(",") : null;

				const result = await onSubmitUpdateActivity(activity, strFileUploaded);
				if (!result.status) {
					setUpdateActivitiesNote({ activity_id: _activities[i].id, status: false, message: t('COMPLETE_ACTIVITY_FAIL') });
					break;
				} else {
					countProcess++;
				}
			}
			console.log('countProcess:', countProcess);
			if (countProcess == _activities.length) {
				await sleep(4000);
				await onLoadListInstallation();
				props.onReloadInstallationList();
				setShowOrderDetail(false);
			}
		} catch (ex) {
			showMessage({ status: true, message: t('EXCEPTION_PROCESS') })
		}
		setShowProcessing(false);
	}

	const onCompleteOrder = async () => {
		setShowProcessing(true);
		try {
			await updateOrderCustomFields();
			const result = await crmservices.orders.completeOrder(orderDetail.id);
			if (result.code == 'OK') {
				onLoadListInstallation();
				setShowOrderDetail(false);
				setShowProcessing(false);
				props.onReloadInstallationList();
			} else {
				showMessage({ staus: true, message: t('COMPLETE_ORDER_FAILED') })
			}
		} catch (ex) {
			showMessage({ staus: true, message: t('EXCEPTION_PROCESS') })
		}
	}

	const updateOrderCustomFields = async () => {
		try {
			let custom_fields = orderDetail.custom_fields;
			let filterCustomFields = custom_fields.filter(c => {
				return c.key != 'enable_devices'
			})
			filterCustomFields.push({
				key: 'enable_devices',
				value: 0
			})
			console.log("filterCustomFields ex:", filterCustomFields);
			await crmservices.orders.updateOrder({ custom_fields: filterCustomFields, order_id: orderDetail.id });
		} catch (ex) {
			console.log("AAAAAAA ex:", ex);
		}
	}

	const onSaveFilesState = () => {
		console.log('filesUpload:',filesUpload);
		if (filesUpload && filesUpload.length > 0) {
			let _files = files.filter(f => {
				return f.activity_id != activityForUpload.id
			})
			console.log('_files:',_files);
			let object = {
				activity_id: activityForUpload.id,
				filesUpload: filesUpload
			}
			console.log('2222 _files:',_files);
			_files.push(object);
			console.log('33333 _files:',_files);
			setFiles(_files);
		}
		setShowUploadFile(false);
	}

	const uploadFiles = (files) => {
		if (files.length > MAXIUM_FILE) {
			showMessage({ status: true, message: t('error_max_files') })
			return false;
		}
		setFilesUpload(files);
	}

	const onUploadFile = async (activity) => {
		console.log("AAAA onUploadFile files: ", files)
		let _filesUploaded = [];
		try {
			let _files = files.filter(f => {
				return f.activity_id == activity.id;
			})
			let fileWillbeUpload = _files && _files.length > 0 ? _files[0].filesUpload : [];
			if (fileWillbeUpload.length > 0) {
				for (let i = 0; i < fileWillbeUpload.length; i++) {
					const result = await crmservices.attachments.uploadFiles({ file: fileWillbeUpload[i], disalbedContentType: true });
					console.log("AAAA onUploadFile result: ", result)
					if (result.code == 'OK' && result.data.id) {
						const addContactResult = await onAddContactAttachment(result.data.id);
						if (addContactResult) {
							_filesUploaded.push(result.data.id)
						}
					}
				}
			}
		} catch (error) {
			console.log("onUploadFile exception:", error);
		}
		return _filesUploaded
	}

	const onDeleteFile = (activity, file) => {
		console.log("file==", file);
		let _files = files.filter(f => {
			return f.activity_id!= activity.id;
		})
		setFiles(_files);
	}

	const get_url_extension = (url) => {
		return url.split(/[#?]/)[0].split('.').pop().trim();
	}

	const onShowFile = async (file) => {
		setShowProcessing(true);
		try {
			let extention = get_url_extension(file.name);
			console.log("extention:", extention);
			const accessToken = getData('access_token')
			var url = connection.crmConfig.crmServer + '/backoffice/v1/files/' + file.id;
			let result = await fetch(url, {
				headers: {
					Authorization: `Bearer ${accessToken}`,
					method: 'GET',
				}
			});
			let resultBlob = await result.blob();
			window.open(window.URL.createObjectURL(resultBlob))
		} catch (error) {
			console.log("load files service request exception:", error);
		}
		setShowProcessing(false);
	}

	const onShowUploadFile = (activity) => {
		setShowUploadFile(true);
		setActivityForUpload(activity);
	}
	return (
		<>
			<InstallationView
				installations={installations}
				showLoadingInstallation={showLoadingInstallation}
				paging={paging}
				handleChangePage={handleChangePage}
				handleChangeRowsPerPage={handleChangeRowsPerPage}
				onShowDetail={onShowDetail}
			/>
			{showOrderDetail && <InstallationDetailView
				isOpen={showOrderDetail}
				orderDetail={orderDetail}
				activities={activities}
				updateActivitiesNote={updateActivitiesNote}
				files={files}
				onClose={() => setShowOrderDetail(false)}
				onChangeNote={onChangeNote}
				onCompleteAllActivity={onCompleteAllActivity}
				onCompleteActivity={onCompleteActivity}
				onCompleteOrder={onCompleteOrder}
				setShowUploadFile={setShowUploadFile}
				onShowUploadFile={onShowUploadFile}
				onDeleteFile={onDeleteFile}
				onShowFile={onShowFile}
			/>}
			{showUploadFile && <ConfirmComponent isOpen={showUploadFile} enableCloseButton={true}
				title={'Upload File'}
				otherMessage={<UploadFile onUploadFile={uploadFiles} isMultipleFile={true} />}
				onClose={() => setShowUploadFile(false)}
				onAction={() => onSaveFilesState()}
			/>}
		</>
	)
}